// CustomListItem.js
import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import { Link as RouterLink, useLocation } from "react-router-dom";

const ListItemWrapper = styled(ListItemButton)(({ theme, open, selected }) => ({
  display: "flex",
  flexDirection: open ? "row" : "column",
  alignItems: "center",
  justifyContent: "center",
  color: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  // height: 'auto',
  "& .MuiListItemText-root": {
    // marginTop: open ? 0 : '8px',
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    opacity: open ? 1 : 1,
    textAlign: open ? "left" : "center",
  },
  "& .MuiListItemIcon-root": {
    // marginBottom: open ? 0 : '4px',
    marginTop: open ? 0 : "-5px",
    justifyContent: open ? "inherit" : "center",
    color: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  },
}));

const CustomListItem = ({ icon: Icon, text, open, to }) => {
  const location = useLocation();
  const { pathname } = location;

  return (
    <ListItemWrapper
      component={RouterLink}
      to={to}
      selected={pathname?.split("/")[1] === to?.split("/")[0]}
      open={open}
    >
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <ListItemText
        primary={text}
        primaryTypographyProps={{
          sx: {
            fontSize: open ? "inherit" : "0.7rem",
            transition: (theme) =>
              theme.transitions.create("font-size", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
          },
        }}
      />
    </ListItemWrapper>
  );
};

export default CustomListItem;
